import React from "react";
import RegisterStaffForm from "../../components/eventLayout/settings/staffManagement/RegisterStaffForm";

const RegisterOrganizerStaff = () => {
  return <RegisterStaffForm />;
};

export default RegisterOrganizerStaff;
